"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const SongwriterRegistrationHeader = () => (react_1.default.createElement(ContentHeader_1.default, { title: 'Songwriter Name', descriptionElement: react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, "To make sure we find the correct songs (also known as musical works) associated with your songwriter name, we need some information from you!"),
        react_1.default.createElement("p", null, "Use the form below to enter the most recent name you have written songs under and a Writer IPI if you have one."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Note:"),
            " If you have written under variations or pseudonyms of your name, you can search for them in the next step.")) }));
exports.default = SongwriterRegistrationHeader;
